import { React, useState, useEffect, useContext } from "react";
import Table from "react-bootstrap/Table";
import ClipLoader from "react-spinners/ClipLoader";
import GlobalContext from "../../providers/GlobalProvider";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "../Transactions/Transactions.css";
import Button from "react-bootstrap/Button";

// const ProcessedTransactions = ({ type }) => {
const ProcessedTransactions = () => {
  const navigate = useNavigate();
  // const [invoicesType, setInvoicesType] = useState(type || "sal");
  const [invoicesType, setInvoicesType] = useState("sal");
  const [loading, setLoading] = useState(true);
  const { defaultMapper } = useContext(GlobalContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [transactionsCount, setTransactionsCount] = useState(0);
  const [transactionHeads, setTransactionHeads] = useState([]);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState({});
  const [isViewing, setIsViewing] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [invoiceNumber, setInvoiceNo] = useState("");

  const invoicesTypesOptions = {
    Sales: "sal",
    Vendor: "vendor",
    CreditNotes: "credit note",
  };

  const url = "api/processed-transactions";

  const getTransactionData = async (page, size) => {
    try {
      const response = await axios.get(
        url + `?pageNumber=${page}&pageSize=${size}&type=${invoicesType}`
      );
      setTransactionHeads(response.data.transactionsHead);
      setTransactionsCount(response.data.transactionCount);
    } catch (e) {
      console.error("Error fetching data:", e);
    }
    setLoading(false);
  };
  const handleDataExport = async () => {
    try {
      await axios.post(`api/transactions/export`);
      window.location.reload();
    } catch (e) {
      console.error("Error exporting row:", error);
    }
  };

  const handleRowExport = async (transId) => {
    try {
      await axios.post(url + `/export/${transId}`);
      window.location.reload();
    } catch (e) {
      console.error("Error exporting row:", error);
    }
  };

  const processDate = (date) => {
    let newDate = new Date(date).toUTCString();

    return newDate;
  };
  const handleSelectInvoiceType = (event) => {
    console.log(event.target.value);

    setInvoicesType(event.target.value);
  };
  const handlePageChange = (page) => setCurrentPage(page);
  const totalPages = Math.ceil(transactionsCount / pageSize);

  const handleViewMore = async (transId) => {
    window.open(`/processed-transactions/${transId}`, "_blank");
  };

  const clearErrorHandler = () => {
    setError({});
  };

  const importSingleInvoice = async () => {
    console.log("Importing invoice with number:", typeof invoiceNumber);
    if (invoiceNumber) {
      try {
        await axios.post(`${url}/import/${invoiceNumber}?type=${invoicesType}`);
        window.location.reload();
      } catch (e) {
        console.error("Error importing invoice:", e);
      }
    }
  };
  const searchInvoice = async () => {
    if (invoiceNumber) {
      try {
        setLoading(true);
        const response = await axios.get(
          `${url}/transactions/${invoiceNumber}?type=${invoicesType}`
        );
        setTransactionHeads(response.data);
        setTransactionsCount(1);
        setCurrentPage(1);
      } catch (e) {
        console.error("Error searching invoice:", e);
        setTransactionHeads([]);
        setTransactionsCount(0);
      }
    } else {
      getTransactionData(currentPage, pageSize, invoicesType);
    }
    setInvoiceNo("");
    setLoading(false);
  };

  useEffect(() => {
    getTransactionData(currentPage, pageSize, invoicesType);
  }, [defaultMapper, currentPage, invoicesType]);

  if (loading) {
    return (
      <div>
        <ClipLoader
          loading={loading}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  return (
    <>
      <select
        className="col-4 mt-2 mb-2 selectors"
        onChange={handleSelectInvoiceType}
        value={invoicesType}
      >
        <option value="">Select Invoices Type</option>
        {Object.keys(invoicesTypesOptions).map((key) => (
          <option key={key} value={invoicesTypesOptions[key]}>
            {key}
          </option>
        ))}
      </select>
      <div className="d-flex justify-content-between align-items-start mb-3">
        <div className="d-grid gap-2 me-3">
          <button
            className="btn btn-outline-primary  w-70"
            onClick={() => setExpanded(!expanded)}
          >
            Import by InvoiceNo
          </button>

          {expanded && (
            <div className="d-flex gap-2">
              <input
                className="form-control  w-100 "
                type="text"
                placeholder="Enter InvoiceNo"
                value={invoiceNumber}
                onChange={(e) => setInvoiceNo(e.target.value)}
              />
              <button
                className="btn btn-outline-primary  w-50"
                onClick={importSingleInvoice}
              >
                Import
              </button>
            </div>
          )}
        </div>

        <div className="d-flex gap-2 ms-auto">
          <input
            className="form-control  w-100 "
            type="text"
            placeholder="Search by InvoiceNo"
            value={invoiceNumber}
            onChange={(e) => setInvoiceNo(e.target.value)}
          />
          <button className="btn btn-outline-primary" onClick={searchInvoice}>
            Search
          </button>
        </div>
      </div>

      <Table hover bordered={false} responsive order className="mt-4 mb-4">
        <thead>
          <tr>
            <th>Name</th>
            <th>Invoice No</th>
            <th>Currency</th>
            <th>Total</th>
            <th>Value Date</th>
            <th>Posted</th>
            <th>Last Export Date</th>
            <th>Errors</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {transactionHeads && transactionHeads.length > 0 ? (
            transactionHeads.map((transaction) => (
              <>
                <tr key={transaction.transId}>
                  <td>{transaction.businessName}</td>
                  <td>{transaction.description}</td>
                  <td>{transaction.currency}</td>
                  <td>{transaction.total}</td>
                  <td>{processDate(transaction.valueDate)}</td>
                  <td>{transaction.posted}</td>
                  <td>{processDate(transaction.lastExportAttempt)}</td>
                  <td>{transaction.error}</td>
                  <td>
                    <Button
                      variant="outline-info"
                      onClick={() => handleViewMore(transaction.transId)}
                    >
                      More
                    </Button>
                  </td>

                  <td>
                    <Button
                      variant="outline-success"
                      onClick={() => handleRowExport(transaction.transId)}
                      disabled={transaction.posted == 1}
                    >
                      Export
                    </Button>
                  </td>
                </tr>
              </>
            ))
          ) : (
            <tr>
              <td colSpan="22">No Transactions Found</td>
            </tr>
          )}
        </tbody>
      </Table>
      {/* Pagination start*/}
      <div>
        <Button
          variant="outline-light"
          onClick={() => handlePageChange(1)}
          disabled={currentPage == 1}
        >
          First
        </Button>
        <Button
          variant="outline-light"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage == 1}
        >
          Previous
        </Button>
        <span className="pagination-count">
          Page {currentPage} of {totalPages}
        </span>
        <Button
          variant="outline-light"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage == totalPages}
        >
          Next
        </Button>
        <Button
          variant="outline-light"
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage == totalPages}
        >
          Last
        </Button>
      </div>
      {/* Pagination end*/}
      <Link to="/">
        <Button variant="outline-danger">Main Menu</Button>
      </Link>
      <Button variant="outline-primary" onClick={handleDataExport}>
        Export Data
      </Button>
    </>
  );
};

export default ProcessedTransactions;
